<script lang="ts">
  import { copy } from "../lib/stores/copy";
  import ActivisionErrorDetails from "../components/ActivisionErrorDetails.svelte";
  import { route } from "../lib/stores/route";
  import { isPrimaryCampaign } from "../lib/constants/countries";
  import { urls } from "../lib/constants/urls";

  export let onErrorRetry: () => void = () => { window.location.reload(); };

  $: errorType = $copy.error[$route.errorSetting];
  $: title = errorType?.title ?? $copy.error.generic.title;
  $: subtitle = errorType?.subtitle ?? $copy.error.generic.subtitle;
  $: info = errorType?.info ?? "";
  $: retryButton = errorType?.retryButton;
  $: renderActivisionErrorDetails = errorType?.renderActivisionErrorDetails;
</script>

<main class="bg-cover bg-no-repeat bg-[center_top] bg-[url('/bg/mobile-bg5.webp')] tablet:bg-[url('/bg/primary-bg.webp')] flex flex-col grow relative bg-dark content-center pb-[calc(118px+1rem)] laptop:pb-0 min-h-full">
  <div class="relative flex items-center flex-col justify-center grow px-4 tablet:px-0">
    <div class="p-4 bg-black/50 rounded-md my-4 w-full tablet:w-auto">
      <div class="text-center">
        <h1 class="font-MrEavesXLSanNarOTUltra flex flex-col items-center text-primary whitespace-normal leading-[0.75] uppercase mb-[14px] text-[50px] tablet:block tablet:whitespace-nowrap laptop:mb-[20px] mobileS:text-[62px] mobile:text-[84px] tablet:text-[84px] laptop:text-[100px] desktop:text-[110px] desktopLg:text-[140px]">
          {title}
        </h1>
        <div class="font-MrEavesXLSanNarOTUltra text-white font-black leading-[0.9] uppercase text-[16px] mobileS:text-[20px] tablet:text-[24px] laptop:text-[26px] desktop:text-[30px] desktopLg:text-[37px]">
          {subtitle}
        </div>
        {#if info}
          <div class="font-MrEavesXLSanNarOT text-white font-black leading-[0.9] text-[16px] mt-[16px] mobileS:text-[20px] tablet:text-[24px] laptop:text-[26px] desktop:text-[30px] desktopLg:text-[37px]">
            {@html info}
          </div>
        {/if}
        {#if renderActivisionErrorDetails}
          <ActivisionErrorDetails />
        {/if}
      </div>
      {#if retryButton}
        <div class="mt-[50px]">
          <div class="max-w-[1100px] mx-auto">
            <div class="flex flex-col items-center">
              <div class="relative flex items-center justify-center w-full max-w-[360px]">
                {#if $route.errorSetting === "campaignNotSupported"}
                  <a
                    href={isPrimaryCampaign ? $urls.internationalCampaign : $urls.primaryCampaign }
                    class="std-button font-MrEavesXLSanNarOTUltra relative inline-flex justify-center items-center text-[16px] whitespace-nowrap text-white px-[12px] uppercase h-[42px] min-w-[132px] bg-dark border-solid border-white border-2 no-underline uppercase transition cursor-pointer overflow-hidden tablet:text-[18px] tablet:h-[48px]">
                    <span class="relative z-[1]">
                      {retryButton}
                    </span>
                  </a>
                {:else}
                  <a
                    href="/"
                    on:click|preventDefault={onErrorRetry}
                    class="std-button font-MrEavesXLSanNarOTUltra relative inline-flex justify-center items-center text-[16px] whitespace-nowrap text-white px-[12px] uppercase h-[42px] min-w-[132px] bg-dark border-solid border-white border-2 no-underline uppercase transition cursor-pointer overflow-hidden tablet:text-[18px] tablet:h-[48px]">
                    <span class="relative z-[1]">
                      {retryButton}
                    </span>
                  </a>
                {/if}
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</main>
